const settings = {
  namespaced: true,
  state: {
    loading: false,
    alert: {
      type: 'S',
      msg: 'Se proceso correctamente',
      isAlert: false
    }
  },
  mutations: {
    SET_LOADING(state, status) {
      state.loading = status
    },
    SET_ALERT(state, value) {
      state.alert.type = value.type
      state.alert.msg = value.msg
      state.alert.isAlert = value.isAlert
    }
  },
  actions: {}
}

export default settings
